<script setup lang="ts">
import { useRouter } from 'vue-router';
import SubmissionPipeline from './SubmissionPipeline.vue';


// Variable Declarations
const router = useRouter();


// Function Declarations
const goToForm = (route: string) => {
    router
        .push({ name: route })
        .catch((err) => {
            console.log(err);
        });
};

</script>

<template>
    <div class="w-full">
        <!-- Header Section -->
        <section class="w-full min-h-[30vh] sm:min-h-[40vh] bg-gradient-to-br from-violet-600 to-violet-800 flex items-center justify-center text-white py-16 sm:py-24 px-4 relative overflow-hidden">
            <div class="absolute inset-0 bg-black/10"></div>
            <div class="relative z-10 text-center">
                <h1 class="font-satoshibold text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-4">Arts & Humanities</h1>
            </div>
            <button 
                class="absolute bottom-0 right-0 px-6 sm:px-8 py-3 sm:py-4 bg-violet-900/90 hover:bg-violet-900 text-white font-satoshibold text-lg sm:text-xl md:text-2xl rounded-tl-2xl transition-all duration-300 hover:shadow-lg cursor-pointer z-10"
                @click="goToForm('guidelines')"
            >
                Submit Here
            </button>
        </section>

        <!-- Content Section -->
        <section class="w-full flex flex-col items-center py-12 sm:py-16 lg:py-20 px-4 sm:px-6">
            <div class="w-full max-w-6xl space-y-12 sm:space-y-16">
                <!-- About Section -->
                <div class="w-full">
                    <h2 class="text-2xl sm:text-3xl lg:text-4xl font-satoshibold text-[#012331] mb-6">
                        About
                    </h2>
                    <div class="w-full sm:w-3/4 lg:w-2/3 text-base sm:text-lg lg:text-xl font-satoshi text-[#012331] leading-relaxed">
                        <p>
                            This journal is dedicated to showcasing the creative and scholarly achievements of undergraduate students in the fields of arts and humanities. 
                            Each edition will feature original work in literature, history, philosophy, visual arts, cultural studies, and other related disciplines. Our goal is to provide a spotlight for thought-provoking contributions of undergraduate students to foster a setting for diverse perspectives and ideas.
                        </p>
                    </div>
                </div>

                <!-- Submission Pipeline -->
                <div class="w-full">
                    <SubmissionPipeline />
                </div>
            </div>
        </section>
    </div>
</template>